module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    "use strict";
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = "<%\nvar DnsMode = require('./NetSimConstants').DnsMode;\n%>\n<%\n/**\n * This block destructures the local variables for use within this ejs template.\n */\nvar dnsMode = locals.dnsMode;\nvar tableData = locals.tableData;\n%>\n<div class=\"netsim-dns-table\">\n  <h1>My Network</h1>\n  <table>\n    <thead>\n    <tr>\n      <th>Hostname</th>\n      <th>Address</th>\n    </tr>\n    </thead>\n    <tbody>\n    <%\n    tableData.forEach(function (row) {\n      var displayHostname = row.hostname;\n      var displayAddress = '';\n      var rowClasses = [];\n\n      if (dnsMode === DnsMode.NONE || row.isDnsNode || row.isLocal) {\n        displayAddress = row.address;\n      }\n\n      if (row.isLocal) {\n        displayHostname += \" (Me)\";\n        rowClasses.push('local-node');\n      }\n\n      if (row.isDnsNode && dnsMode !== DnsMode.NONE) {\n        displayHostname += \" (DNS)\";\n        rowClasses.push('dns-node');\n      }\n      %>\n        <tr class=\"<%= rowClasses.join(' ') %>\">\n          <td><%= displayHostname %></td>\n          <td><%= displayAddress %></td>\n        </tr>\n      <%\n    });\n    %>\n    </tbody>\n  </table>\n</div>", __filename = "src/netsim/NetSimDnsTable.html.ejs";
    try {
        var __output = "";
        function __append(s) {
            if (s !== undefined && s !== null) __output += s;
        }
        var DnsMode = require("./NetSimConstants").DnsMode;
        __line = 3;
        __append("\n");
        __line = 4;
        var dnsMode = locals.dnsMode;
        var tableData = locals.tableData;
        __line = 10;
        __append('\n<div class="netsim-dns-table">\n  <h1>My Network</h1>\n  <table>\n    <thead>\n    <tr>\n      <th>Hostname</th>\n      <th>Address</th>\n    </tr>\n    </thead>\n    <tbody>\n    ');
        __line = 21;
        tableData.forEach(function(row) {
            var displayHostname = row.hostname;
            var displayAddress = "";
            var rowClasses = [];
            if (dnsMode === DnsMode.NONE || row.isDnsNode || row.isLocal) {
                displayAddress = row.address;
            }
            if (row.isLocal) {
                displayHostname += " (Me)";
                rowClasses.push("local-node");
            }
            if (row.isDnsNode && dnsMode !== DnsMode.NONE) {
                displayHostname += " (DNS)";
                rowClasses.push("dns-node");
            }
            __line = 40;
            __append('\n        <tr class="');
            __line = 41;
            __append(escapeFn(rowClasses.join(" ")));
            __append('">\n          <td>');
            __line = 42;
            __append(escapeFn(displayHostname));
            __append("</td>\n          <td>");
            __line = 43;
            __append(escapeFn(displayAddress));
            __append("</td>\n        </tr>\n      ");
            __line = 45;
        });
        __line = 47;
        __append("\n    </tbody>\n  </table>\n</div>");
        __line = 50;
        return __output;
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}